/** Matches coin-api GemLanguageResolver::SUPPORTED_LANGUAGES */
export const GEM_LANGUAGE_CODES = ["en", "de", "fr", "es", "pt", "it", "nl", "ja", "ar"];

export const GEM_LANGUAGE_OPTIONS = [
  { value: "en", label: "English (gems)" },
  { value: "de", label: "German (gems_de)" },
  { value: "fr", label: "French (gems_fr)" },
  { value: "es", label: "Spanish (gems_es)" },
  { value: "pt", label: "Portuguese (gems_pt)" },
  { value: "it", label: "Italian (gems_it)" },
  { value: "nl", label: "Dutch (gems_nl)" },
  { value: "ja", label: "Japanese (gems_ja)" },
  { value: "ar", label: "Arabic (gems_ar)" }
];

export function gemTableLabel(languageCode) {
  if (!languageCode || languageCode === "en") {
    return "gems";
  }
  return `gems_${languageCode}`;
}
